import React from 'react';
import { motion } from 'framer-motion';
import './YoutubeHero.css';

const YoutubeHero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <section className="yt-hero-section">
      <div className="yt-hero-content">
        <motion.div 
          className="yt-hero-text"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h4 variants={itemVariants} className="yt-hero-tag">
            <span className="tag-muted">YOUTUBE</span> <span className="tag-highlight">PROMOTION</span>
          </motion.h4>
          <motion.h1 variants={itemVariants} className="yt-hero-title">
            GET YOUTUBE<br/>
            WORKING FOR<br/>
            <span className="gradient-text">YOUR MUSIC</span>
          </motion.h1>
          <motion.p variants={itemVariants} className="yt-hero-description">
            Monetize your tracks, protect your rights, and grow your channel with our premium Youtube music promotion.
          </motion.p>
          
          <motion.div variants={itemVariants} className="yt-hero-trusted">
            <p>TRUSTED BY 10,000+ ARTISTS</p>
            <div className="yt-avatars">
               <div className="yt-avatar"><img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop" alt="Artist 1"/></div>
               <div className="yt-avatar"><img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop" alt="Artist 2"/></div>
               <div className="yt-avatar"><img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop" alt="Artist 3"/></div>
               <div className="yt-avatar-count">+9k</div>
            </div>
          </motion.div>
        </motion.div>
        
        <motion.div 
          className="yt-hero-visual"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        >
          <img src="/youtube-assets/hero_mic.png" alt="Studio Microphone" className="yt-3d-image" />
        </motion.div>
      </div>
    </section>
  );
};

export default YoutubeHero;
